import { useHistory } from 'react-router-dom';
import IconBrowser from '../../../assets/icons/fleet/icon-browser.svg';
import Card from '../../../components/Fleets/Card';
import Head from '../../../components/Head';


const OrderCanceled = () => {
  const history = useHistory();


  const handleRedirect = () => {
    history.push('/dashboard');
  };

  return (
    <>
        <Head>Frotas</Head>
        <Card
          icon={IconBrowser}
          title="Solicitação Cancelada"
          text="Você receberá um e-mail com a confirmação do cancelamento do pedido de compra."
          onButtonClick={handleRedirect}
        />
    </>
  );
};
export default OrderCanceled;
